<template>
  <div>
    <custom-actions>
      <template #header>
        <!-- <el-button type="primary">导出</el-button> -->
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item label="油罐名称" prop="ygCode">
          <el-input clearable v-model="searchForm.ygCode" placeholder="请输入油罐名称" />
        </el-form-item>
        <el-form-item prop="ygType" label="储油规格">
          <el-select v-model="searchForm.ygType" clearable filterable placeholder="请选择储油规格">
            <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="ygRegion" label="所属库区">
          <el-select v-model="searchForm.ygRegion" clearable filterable placeholder="请选择所属库区">
            <el-option v-for="([key, value], index) of regionMap" :value="key" :label="value"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="油罐名称" prop="ygCode"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="所属区域" prop="ygRegion">
          <template v-slot="{ row }">
            {{ regionMap.get(row.ygRegion) }}
          </template>
        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip min-width="140" label="所属用户" prop="userName"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip min-width="120" label="当前液位(米)" prop="ygLevel"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip min-width="120" label="当前温度(℃)" prop="ygTemperature"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip label="直径(米)" prop="ygDiameter"></el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="130" label="总容量(吨)" prop="ygAllWeight"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="130" label="当前存油量(吨)" prop="ygWeight"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip min-width="150" label="当前密度(Kg/m3)" prop="ygDensity"></el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="110" label="储油规格" prop="ygTypeName"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip min-width="120" label="油罐高度(米)" prop="ygHeight"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip min-width="120" label="租赁到期时间" prop="ygLeaseTerm"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip min-width="140" label="更新时间" prop="ygTime"></el-table-column> -->
        <el-table-column fixed="right" label="操作" width="130">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/oiltankManage/detail?id=' + row.ygId)">详情</el-button>
            <el-button type="text" v-visible="'edit'" @click="$router.push('/oiltankManage/edit?id=' + row.ygId)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--
      <el-pagination
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination> -->
    </el-card>
  </div>
</template>

<script>
import { region } from '@/utils/dict'
export default {
  name: 'OiltankManage',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        ygCode: null,
        ygType: null,
        ygRegion: null
      },
      regionMap: region,
      specList: []
    }
  },
  created () {
    this.loadSpecList()
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList, {
        params: {
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    loadSpecList() {
      this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list || []
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        ygCode: null,
        ygType: null,
        ygRegion: null
      }
      this.onSearch()
    },
    deleteRow (id) {
      // this.$confirm('确认删除该记录, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$axios.post(this.$apis.oiltabkManage.xxxx, {
      //     id
      //   }).then(() => {
      //     this.loadData()
      //   })
      // })
    }
  }
}
</script>

<style scoped lang='scss'></style>
